import { useEffect } from "react";
import Footer from "../../../components/footer";
import PageBackgroundPattern from "../../../components/PageBackgroundPattern";
import JugadoresFilters from "../components/JugadoresFilters";
import JugadoresHeader from "../components/JugadoresHeader";
import JugadoresList from "../components/JugadoresList";
import useJugadoresData from "../hooks/useJugadoresData";

function Jugadores() {
    const {
        isLoading,
        isError,
        hasData,
        searchTerm,
        setSearchTerm,
        jugadores,
        totalJugadores,
        filteredTotal,
        currentPage,
        totalPages,
        pageNumbers,
        onPageChange,
    } = useJugadoresData();

    useEffect(() => {
        document.title = "Jugadores";
    }, []);

    return (
        <div className="relative min-h-screen overflow-hidden bg-[#062a1a] pt-16">
            <PageBackgroundPattern />
            <main className="relative z-10 max-w-7xl mx-auto w-full px-4 md:px-10 pt-2 pb-8 md:pb-10">
                <JugadoresHeader />

                <JugadoresFilters
                    searchTerm={searchTerm}
                    onSearchTermChange={setSearchTerm}
                />

                <JugadoresList
                    isLoading={isLoading}
                    isError={isError}
                    hasData={hasData}
                    jugadores={jugadores}
                    filteredTotal={filteredTotal}
                    totalJugadores={totalJugadores}
                    currentPage={currentPage}
                    totalPages={totalPages}
                    pageNumbers={pageNumbers}
                    onPageChange={onPageChange}
                />
            </main>

            <div className="relative z-10">
                <Footer />
            </div>
        </div>
    );
}

export default Jugadores;
